module.exports = __webpack_public_path__ + "1_0_61/img/calendar_task.9a3eb4e3.svg";